module.exports = __webpack_public_path__ + "img/sign_230410681_1.acb7a836.png";